export default __webpack_public_path__ + "static/media/akinsete.a2afc332.png";